import { render, staticRenderFns } from "./ExternalStatistics.vue?vue&type=template&id=0a2e489a&scoped=true&"
import script from "./ExternalStatistics.vue?vue&type=script&lang=js&"
export * from "./ExternalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e489a",
  null
  
)

export default component.exports